import { render, staticRenderFns } from "./formTaskCard.vue?vue&type=template&id=cf6db70a&"
import script from "./formTaskCard.vue?vue&type=script&lang=js&"
export * from "./formTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports